import { z } from "zod";
export const defaultDocsRenderCodePackageJson = `{
  "name": "supernova-live-react",
  "version": "1.0.0",
  "description": "Live React Code Packager",
  "keywords": ["react", "supernova"],
  "main": "src/index.js",
  "dependencies": {
    "react-dom": "latest",
    "react": "latest"
  },
  "devDependencies": {
    "@babel/runtime": "7.13.8",
    "typescript": "4.1.3"
  },
  "scripts": {
    "start": "react-scripts start",
    "build": "react-scripts build",
    "test": "react-scripts test --env=jsdom",
    "eject": "react-scripts eject"
  },
  "browserslist": [">0.2%", "not dead", "not ie <= 11", "not op_mini all"]
}`;
export const DocumentationConfiguration = z.object({
    // Basic
    designSystemVersionId: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    // Configuration
    isTabbedLayoutEnabled: z.boolean(),
    storybookEmbedErrorMessage: z.string().optional(),
    renderCodePackageJson: z.string().optional(),
    selectedBrandPersistentId: z.string().optional(),
    serveDefaultVersionOnly: z.boolean(),
    isPublic: z.boolean(),
});
